export default __webpack_public_path__ + "123e8be076dbea4c65383f1776c9f478.mov";